import Service from "../Service";

const resource = "position/";

export default {
  getPositionProfileAll(PstID, requestID) {
    return Service.post(resource + "getPositionProfile", null, {
      params: { PstID: PstID, requestID: requestID },
    });
  },
  getStructureDetailByPstid(PstID, requestID) {
    return Service.post(resource + "structuredetailbypstid", null, {
      params: { PstID: PstID, requestID: requestID },
    });
  },
  getPositionDescriptionByPstID(PstID, requestID) {
    return Service.post(resource + "getPositionDescriptionByPstID", null, {
      params: { PstID: PstID, requestID: requestID },
    });
  },
  // ⚡ NUEVO: Endpoint consolidado para imprimir
  getPrintableRequirementData(ReqID, PstID, requestID, printType = "all") {
    return Service.post(resource + "getPrintableRequirementData", null, {
      params: { ReqID, PstID, requestID, printType },
    });
  }
};
